import { ShowImageArtistInstrument } from "@/components/showImage/ShowImageArtistInstrument";
import { ShowImageMixedModel } from "@/components/showImage/ShowImageMixedModel";
import { ShowImageModel } from "@/components/showImage/ShowImageModel";
import {
  Artist,
  Instrument,
  MixedModelConstructedNoDates,
  ModelNoDates,
} from "@/types/types";

export function ShowImageArtistInstrumentModelMixedModel({
  artistInstrumentModelMixedModel,
}: {
  artistInstrumentModelMixedModel:
    | Artist
    | Instrument
    | ModelNoDates
    | MixedModelConstructedNoDates;
}) {
  // If artistInstrumentModelMixedModel is an Artist or Instrument
  if ("image" in artistInstrumentModelMixedModel) {
    return (
      <ShowImageArtistInstrument
        artistInstrument={artistInstrumentModelMixedModel}
      />
    );
  }

  // If artistInstrumentModelMixedModel is a Model
  if ("presignedUrlImage" in artistInstrumentModelMixedModel) {
    return <ShowImageModel model={artistInstrumentModelMixedModel} />;
  }

  // If artistInstrumentModelMixedModel is a MixedModel
  return <ShowImageMixedModel mixedModel={artistInstrumentModelMixedModel} />;
}
